import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
    },
    masterContainer: { 
      margin: theme.spacing(2),
    },
    table: {
      minWidth: '90%',
    },
  }));